define('helpers/UIHelper',[], function() {
  return {
    expandBackground: function () {
      $('.login__page').css('min-height', $(window).height() - $('footer').height() );

      return this;
    },

    listeningResize: function () {
      $(window).on('resize', this.expandBackground);
    },

    stopListeningResize: function () {
      $(window).off('resize');
    },
  };
});

